import { useState, useEffect } from 'react'

// Global state to keep all countdowns synchronized across the page
let globalEndTime: number | null = null

export function useCountdown(initialSeconds: number) {
  const [timeLeft, setTimeLeft] = useState(initialSeconds)

  useEffect(() => {
    if (!globalEndTime) {
      globalEndTime = Date.now() + initialSeconds * 1000
    }

    const calculateTimeLeft = () => {
      if (!globalEndTime) return 0
      const difference = globalEndTime - Date.now()
      return Math.max(0, Math.floor(difference / 1000))
    }

    setTimeLeft(calculateTimeLeft())

    const timer = setInterval(() => {
      const remaining = calculateTimeLeft()
      setTimeLeft(remaining)

      if (remaining <= 0) {
        clearInterval(timer)
      }
    }, 1000)

    return () => clearInterval(timer)
  }, [initialSeconds])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  return {
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
    isExpired: timeLeft <= 0,
  }
}
